<template>
    <a-modal :title="$t('platformCollection.earnings_distribution_details')" :width="1200" :visible="visible" :footer="null" @cancel="handleCancel">
        <div class="earnings-detail-container">
            <div class="search-form">
                <a-form layout="inline">
                    <a-form-item>
                        <a-input-group compact>
                            <a-select v-model="queryParam.searchType" style="width: 180px">
                                <a-select-option value="name">{{$t('investorList.hkrxm')}}</a-select-option>
                                <a-select-option value="mobile">{{$t('investorList.hkrsjh')}}</a-select-option>
                            </a-select>
                            <a-input v-model="queryParam.searchValue" style="width: 200px" :placeholder="$t('enter')"
                                allow-clear />
                        </a-input-group>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="handleSearch">{{$t('search')}}</a-button>
                    </a-form-item>
                </a-form>
            </div>

            <a-table bordered :columns="columns" :data-source="dataSource" :pagination="pagination" :loading="loading"
                @change="handleTableChange" :rowKey="(record, index) => record.id ? `${record.id}-${index}` : index">
                <span slot="type" slot-scope="text">
                    {{ typeFilter(text) }}
                </span>
                <span slot="investAmount" slot-scope="text">
                    {{ text | FenToDong }}
                </span>
                <span slot="investRatio" slot-scope="text">
                    {{ text }}%
                </span>
                <span slot="investYieldRate" slot-scope="text">
                    {{ text }}%
                </span>
                <span slot="amount" slot-scope="text">
                    {{ text | FenToDong }}
                </span>
            </a-table>
        </div>
    </a-modal>
</template>

<script>
import { getIncomeDistributionDetail } from '@/webpublicapi/vietnamBackstage'

export default {
    name: 'EarningsDetailsModal',
    data() {
        return {
            visible: false,
            loading: false,
            repayOrderId: undefined,
            queryParam: {
                searchType: 'name',
                searchValue: ''
            },
            dataSource: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`
            }
        }
    },
         computed: {
        columns() {
            return [
                { title: this.$t('investorList.tzrmc'), dataIndex: 'name', align: 'center', width: 160 },
                { title: this.$t('investorList.tzrsjh'), dataIndex: 'mobile', align: 'center', width: 160 },
                { title: this.$t('investorList.tzrlx'), dataIndex: 'type', align: 'center', scopedSlots: { customRender: 'type' }, width: 120 },
                { title: this.$t('investorList.tzje'), dataIndex: 'investAmount', align: 'center', scopedSlots: { customRender: 'investAmount' }, width: 140 },
                { title: this.$t('investorList.tzzb'), dataIndex: 'investRatio', align: 'center', scopedSlots: { customRender: 'investRatio' }, width: 120 },
                { title: this.$t('investorList.nhll'), dataIndex: 'investYieldRate', align: 'center', scopedSlots: { customRender: 'investYieldRate' }, width: 120 },
                { title: this.$t('investorList.fpje'), dataIndex: 'amount', align: 'center', scopedSlots: { customRender: 'amount' }, width: 140 }
            ]
        }
    },
    methods: {
        show(record) {
            // Params:repayOrderId(Assigned repayment ordersID)
            this.visible = true
            this.repayOrderId = record && record.repayOrderId
            this.pagination.current = 1
            this.queryParam.searchValue = ''
            this.loadData()
        },
        handleCancel() {
            this.visible = false
        },
        handleSearch() {
            this.pagination.current = 1
            this.loadData()
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.loadData()
        },
        typeFilter(type) {
            const map = {
                1: this.$t('investorList.gr'),
                10: this.$t('investorList.qy')
            }
            return map[type] || type || '-'
        },
        loadData() {
            if (!this.repayOrderId) {
                this.dataSource = []
                this.pagination.total = 0
                return
            }

            this.loading = true
            const params = {
                pageNo: this.pagination.current,
                pageSize: this.pagination.pageSize,
                repayOrderId: this.repayOrderId
            }

            const keyword = (this.queryParam.searchValue || '').trim()
            if (keyword) {
                params[this.queryParam.searchType] = keyword
            }

            getIncomeDistributionDetail(params)
                .then((res) => {
                    if (res.success && res.respData) {
                        const { records, total, current } = res.respData
                        const list = records || []
                        // Calculate investment ratio = investAmount / investLoanAmount
                        this.dataSource = list.map(item => {
                            const investAmount = Number(item.investAmount)
                            const investLoanAmount = Number(item.investLoanAmount)
                            let ratio = 0
                            if (Number.isFinite(investAmount) && Number.isFinite(investLoanAmount) && investLoanAmount > 0) {
                                ratio = (investAmount / investLoanAmount) * 100
                            }
                            return {
                                ...item,
                                investRatio: Number.isFinite(ratio) ? ratio.toFixed(6) : '0.000000'
                            }
                        })
                        this.pagination.total = total || 0
                        this.pagination.current = current || this.pagination.current
                    } else {
                        this.dataSource = []
                        this.pagination.total = 0
                        this.$message.warning(res.respMsg || res.message || this.$t('platformCollection.query_failed'))
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';

.earnings-detail-container {
    padding: 10px 20px;

    .search-form {
        margin-bottom: 16px;
    }
}
</style>